import { ChangeDetectorRef, Component, ElementRef, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as Highcharts from 'highcharts';
import { ReportingfilterPipe } from '../../cms-common/Pipes/reportingfilter.pipe';
import { MatTableDataSource } from '@angular/material/table';
import { UserInfoService } from '../../spartacus/services/user-info.service';
@Component({
  selector: 'app-reportinguk',
  standalone: false,
  templateUrl: './reportinguk.component.html',
  styleUrls: ['./reportinguk.component.scss']
})
export class ReportingukComponent {

  constructor(private cd: ChangeDetectorRef, private userinfo: UserInfoService,private eleRef:ElementRef) {

  }
  toggleseason: boolean = false;
  toggleview: boolean = false;
  seasoncount: number = 1;
  deliverycount: number = 1;
  seasonObjects: any;
  deliveryObjects: any;
  toggledelivery: boolean = false;
  selectedseason: any[] = [];
  selecteddelivery: any[] = [];
  returndata:any;
  Highcharts: typeof Highcharts = Highcharts;
  Highchartsreturn: typeof Highcharts = Highcharts;
  productname1: string = 'aTIV';
  productname2: string = 'TIVc';
  chartOptions!: Highcharts.Options;
  chartOptionsreturn!: Highcharts.Options;
  orderchartxaxis: any[] = [];
  actuallseason: any[] = [];
  rbavalue:any;
  displayedColumns: string[] = ['Season', 'Location Name', 'Postcode', 'Orders - aTIV', 'Orders - TIVc', 'Returns - aTIV', 'Returns - TIVc'];
  displayedColumnsorders: string[] = ['Season', 'Location Name', 'Postcode', 'Orders - aTIV', 'Orders - TIVc'];
  displayedColumnsreturn: string[] = ['Season', 'Location Name', 'Postcode', 'Returns - aTIV', 'Returns - TIVc'];
  productname1Display: string = '';
  productname2Display: string = '';


  dataSource = new MatTableDataSource<any>();
  yaxisresult: any[] = [];
  yaxisreturn:any[]=[];
  rportingfilterValues = {
    filterbyseason: [''],
    filterbyaddress: [''],
  };
  filteredData1: any;
  selectedOption: string = 'All';
  view = ['All', 'Order', 'Return'];
  obj: any;
  ngOnInit() {
     this.userinfo.reportingdata().subscribe((data: any) => {
    this.obj = data;
    const steps = 5;
    let maxQuantity=Number(this.obj.maxQuantity)<5000?5000:Math.ceil(this.obj.maxQuantity / 10000) * 10000
    let returnmaxQuantity=Number(this.obj.maxQuantity)<5000?5000:Math.ceil(this.obj.maxReturnQuantity / 10000) * 10000
   
    for (let i = 0; i <= steps; i++) {
      // calculate step value
      const value = ((Number(maxQuantity)) / steps) * i;
      // round to nearest thousand 
     
      const formatted = value >= 1000 ? value / 1000 : value;
      this.yaxisresult.push(formatted);
    }
    for (let i = 0; i <= steps; i++) {
      // calculate step value
      const value = ((Number(returnmaxQuantity)) / steps) * i;
      // round to nearest thousand 
      const formatted = value >= 1000 ? value / 1000 : value;
      this.yaxisreturn.push(formatted);
    }
    this.actuallseason = [...this.obj.seasons];
    this.selectedseason=[this.obj.currentSeason];
    this.selecteddelivery.push('All');
    this.obj.seasons.unshift('All seasons');
    this.seasonObjects = this.obj.seasons.map((season: any) => ({ season: season, checked: season === this.obj.currentSeason ? true : false }));
    this.obj.delivery.unshift('All');
    this.deliveryObjects = this.obj.delivery.map((delivery: any) => ({ delivery: delivery, checked: delivery === "All" ? true : false }));
    this.orderchartxaxis = this.selectedseason;
    this.rportingfilterValues.filterbyseason = this.selectedseason;
    this.applyfilter();
    });

    this.rbavalue = localStorage.getItem('rbapermission');
    this.rbavalue = JSON.parse(this.rbavalue);
    //this.setorderHighchart();
    this.cd.detectChanges();
  }
  openseason() {
    this.toggleseason = !this.toggleseason;
  }
  openview() {
    this.toggleview = !this.toggleview;
  }
  opendelivery() {
    this.toggledelivery = !this.toggledelivery;
  }
  resetview() {
    this.selectedOption = 'All';
    this.cd.detectChanges();
  }

  @HostListener('document:click',['$event'])
  onDocumentClick(event:MouseEvent):void{
    const eventhtml=event.target as HTMLElement
    if(this.toggleseason){
      this.toggleseason =false;
      const seasonParent = eventhtml.closest('.season');
       if (seasonParent && this.eleRef.nativeElement.contains(seasonParent)) {
        this.toggleseason = true;
       }
    }
  if(this.toggleview){
    this.toggleview =false;
    const viewParent = eventhtml.closest('.view');
    if (viewParent && this.eleRef.nativeElement.contains(viewParent)) {
      this.toggleview = true;
     }
  }
  if(this.toggledelivery){
    this.toggledelivery =false;
    const deliveryParent = eventhtml.closest('.delivery');
    if (deliveryParent && this.eleRef.nativeElement.contains(deliveryParent)) {
      this.toggledelivery = true;
     }
  }
  }
  seasonchange(event: any) {
    if (event.target.checked) {

      if (event.target.value == 'All seasons') {
        this.seasoncount = 1;

        this.seasonObjects.forEach((season: any) => season.checked = season === "All seasons" ? true : false

        );
        this.selectedseason = ['All seasons'];
        this.rportingfilterValues.filterbyseason = ['']
      }
      else {
        if (this.selectedseason.includes('All seasons')) {
          this.seasonObjects.forEach((season: any) => season.checked = season === "event.target.value" ? true : false);
          this.selectedseason = [event.target.value];
          this.rportingfilterValues.filterbyseason = this.selectedseason
          this.seasoncount = 1;
        } else {
          this.seasoncount++;
          this.selectedseason.push(event.target.value);
          this.rportingfilterValues.filterbyseason = this.selectedseason
        }
      }

    } else {
      if (this.seasoncount > 1) {
        var index = this.selectedseason.indexOf(event.target.value);
        this.selectedseason.splice(index, 1);
        this.seasoncount--;
        this.rportingfilterValues.filterbyseason = this.selectedseason
      }
      else {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    if (this.selectedseason.includes('All seasons')) {
      this.orderchartxaxis = [...this.actuallseason].reverse();
    } else {
      this.orderchartxaxis = [...this.selectedseason].reverse();
    }
  }
  seasonrest() {
    this.seasonObjects.forEach((s: { season: string; checked: boolean }) => { s.checked = s.season === this.obj.currentSeason; });
    console.log(this.seasonObjects)
    this.selectedseason = [this.obj.currentSeason];
    this.orderchartxaxis = this.selectedseason
    this.rportingfilterValues.filterbyseason = this.selectedseason
    this.seasoncount = 1;
  }

    
  

  changedelivery(event: any) {
    if (event.target.checked) {

      if (event.target.value == 'All') {
        this.deliverycount = 1;

        this.deliveryObjects.forEach((delivery: any) => delivery.checked = delivery === "All" ? true : false

        );
        this.selecteddelivery = ['All'];
        this.rportingfilterValues.filterbyaddress = ['']
      }
      else {
        if (this.selecteddelivery.includes('All')) {
          this.deliveryObjects.forEach((delivery: any) => delivery.checked = delivery === "event.target.value" ? true : false);
          this.selecteddelivery = [event.target.value];
          this.deliverycount = 1;
          this.rportingfilterValues.filterbyaddress = this.selecteddelivery
        } else {
          this.deliverycount++;
          this.selecteddelivery.push(event.target.value);
          this.rportingfilterValues.filterbyaddress = this.selecteddelivery
        }
      }

    } else {
      if (this.deliverycount > 1) {
        var index = this.selecteddelivery.indexOf(event.target.value);
        this.selecteddelivery.splice(index, 1);
        this.deliverycount--;
        this.rportingfilterValues.filterbyaddress = this.selecteddelivery
      }
      else {
        event.preventDefault();
        event.stopPropagation();
      }
    }

  }
  deliveryreset() {
    this.deliveryObjects.forEach((s: { delivery: string; checked: boolean }) => { s.checked = s.delivery === "All"; });
    console.log(this.selecteddelivery)
    this.selecteddelivery = ['All'];
    this.rportingfilterValues.filterbyaddress = ['']
    this.deliverycount = 1;
  }
  applyfilter() {
    this.filteredData1 = new ReportingfilterPipe().transform(this.obj.dashboardReportingData, this.rportingfilterValues);
      if(this.selectedOption=='Return'){
        this.returndata=[...this.filteredData1];
        this.returndata = this.returndata.filter((data: any) => { 
          let returnvalue = 0;
           data.products.forEach((each: any) => { 
            returnvalue += Number(each?.returnQuantity) || 0;
             // safe against undefined 
             }); // keep only those with sum > 0 
             return returnvalue > 0; 
          });
   
         this.filteredData1=this.returndata;
         
        }
      
      
      this.dataSource = this.filteredData1;

    let ativquantityorder: any[] = [];
    let ativquantityreturn: any[] = [];
    let tivcquantityorder: any[] = [];
    let tivcquantityreturn: any[] = [];

    let hasA = false; // season >= 2025
    let hasB = false; // season < 2025
    let hasC=false; //season>2026
    this.orderchartxaxis.forEach(season => {
      const year = parseInt(season.split("-")[0], 10);
      if(year>2026){
        hasC=true;
      }
      else if (year >= 2025) {
        hasA = true;
      }
      else {
        hasB = true;
      }
    });

    if (hasA && hasB && hasC) {
      this.productname1 = "Aujemflu/aTIV/aQIV";
      this.productname2 = "TIVc/QIVc";
    }
    else if (hasA && hasC) {
      this.productname1 = "Aujemflu/aTIV";
      this.productname2 = "TIVc";
    }
    else if (hasB && hasC) {
      this.productname1 = "Aujemflu/aQIV";
      this.productname2 = "QIVc";
    }
    else if(hasC){
      this.productname1 = "Aujemflu";
      this.productname2 = "TIVc";
    }
    else if (hasA && hasB) {
      this.productname1 = "aTIV/aQIV";
      this.productname2 = "TIVc/QIVc";
    } else if (hasA) {
      this.productname1 = "aTIV";
      this.productname2 = "TIVc";
    } else if (hasB) {
      this.productname1 = "aQIV";
      this.productname2 = "QIVc";
    }
    this.productname1Display = this.productname1.replace(/\//g, ' ');
    this.productname2Display = this.productname2.replace(/\//g, ' ');

    this.orderchartxaxis.forEach((season: any, index: number) => { // initialize values for each season 
      ativquantityorder.push(0);
      ativquantityreturn.push(0);
      tivcquantityorder.push(0);
      tivcquantityreturn.push(0);


      // find the data for the current season 
      const seasonDataList = this.filteredData1.filter((quantity: any) => quantity.season === season);

      seasonDataList.forEach((item: any,indexnew:number) => {
        item.products.forEach((each: any) => {

          if (each.productName === 'aTIV' || each.productName === 'aQIV' || each.productName === 'Auje') {
            ativquantityorder[index] = Number(ativquantityorder[index]) + Number(each?.orderQuantity);
            if(each?.returnQuantity){
            ativquantityreturn[index] = Number(ativquantityreturn[index]) + Number(each?.returnQuantity);
            }
          }
          else if (each.productName === 'TIVc' || each.productName === 'QIVc') {
            tivcquantityorder[index] = Number(tivcquantityorder[index]) + Number(each?.orderQuantity);
            if(each?.returnQuantity){
            tivcquantityreturn[index] = Number(tivcquantityreturn[index]) + Number(each?.returnQuantity);
            }
          }
        });
      
      });
      ativquantityorder[index] = (Number(ativquantityorder[index]) / 1000)
      ativquantityreturn[index] = (Number(ativquantityreturn[index]) / 1000)
      tivcquantityorder[index] = (Number(tivcquantityorder[index]) / 1000)
      tivcquantityreturn[index] = (Number(tivcquantityreturn[index]) / 1000)

    });
   
    this.setorderHighchart(ativquantityorder, tivcquantityorder);
    this.setreturnHighchart(ativquantityreturn, tivcquantityreturn)
    this.cd.detectChanges();
  }


  formatdata(data: any) {

    if (this.selectedOption == 'All') {
      const extractedData = data.map((entry: any) => ({
        Season: entry.season,
        LocationName: entry.locationName,
        Postcode: entry.postcode,
        [`Orders-${this.productname1}`]: (() => {
          const product = entry.products.find((p: any) => p.productName==='Auje' || p.productName === 'aQIV' || p.productName === 'aTIV'); return product ? product.orderQuantity : null; // store only orderQuantity
        })(),
        [`Orders-${this.productname2}`]: (() => {
          const product = entry.products.find((p: any) => p.productName === 'QIVc' || p.productName === 'TIVc'); return product ? product.orderQuantity : null; // store only orderQuantity
        })(),
        [`Returns-${this.productname1}`]: (() => {
          const product = entry.products.find((p: any) => p.productName ==='Auje' || p.productName === 'aQIV' || p.productName === 'aTIV'); return product ? product.returnQuantity : null; // store only orderQuantity
        })(),
        [`Returns-${this.productname2}`]: (() => {
          const product = entry.products.find((p: any) => p.productName === 'QIVc' || p.productName === 'TIVc'); return product ? product.returnQuantity : null; // store only orderQuantity
        })()

      })

      );
      return extractedData;
    }
    else if (this.selectedOption == 'Order') {
      const extractedData = data.map((entry: any) => ({
        Season: entry.season,
        LocationName: entry.locationName,
        Postcode: entry.postcode,
        [`Orders-${this.productname1}`]: (() => {
          const product = entry.products.find((p: any) => p.productName ==='Auje' || p.productName === 'aQIV' || p.productName === 'aTIV'); return product ? product.orderQuantity : null; // store only orderQuantity
        })(),
        [`Orders-${this.productname2}`]: (() => {
          const product = entry.products.find((p: any) => p.productName === 'QIVc' || p.productName === 'TIVc'); return product ? product.orderQuantity : null; // store only orderQuantity
        })()

      })

      );
      return extractedData;
    } else if (this.selectedOption == 'Return') {
      const extractedData = data.map((entry: any) => ({
        Season: entry.season,
        LocationName: entry.locationName,
        Postcode: entry.postcode,
        [`Returns-${this.productname1}`]: (() => {
          const product = entry.products.find((p: any) => p.productName ==='Auje' || p.productName === 'aQIV' || p.productName === 'aTIV'); return product ? product.returnQuantity : null; // store only orderQuantity
        })(),
        [`Returns-${this.productname2}`]: (() => {
          const product = entry.products.find((p: any) => p.productName === 'QIVc' || p.productName === 'TIVc'); return product ? product.returnQuantity : null; // store only orderQuantity
        })()

      })

      );
      return extractedData;
    }

  }
  convertToCSV(objArray: any[]): string {
    const header = Object.keys(objArray[0]).join(",");
    // column headers 
    //const rows = objArray.map(row => Object.values(row).join(","));
    const rows = objArray.map(row => Object.values(row) .map(val => { 
      // Escape quotes by doubling them 
      if(val){
        const strVal =  String(val).replace(/"/g, '""')
        // Wrap in quotes if it contains comma, newline, or quote
         return /[",\n]/.test(strVal) ? `"${strVal}"` : strVal; 
        
      }else{
        return val
      }
    }).join(",") );
    return [header, ...rows].join("\n");
  }
  handleoncsv() {
    if (this.selectedOption == 'Return') {
      const data = this.formatdata(this.filteredData1)
      const csvData = this.convertToCSV(data);
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = 'Reporting.csv';
      // filename 
      a.click();
      window.URL.revokeObjectURL(url);
    }else{
    const data = this.formatdata(this.filteredData1)
    const csvData = this.convertToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'Reporting.csv';
    // filename 
    a.click();
    window.URL.revokeObjectURL(url);
    }
 
  }
  setorderHighchart(aqiv: any, qivc: any) {
    const orderchartyaxis = this.yaxisresult;
    let formattedSeasons = this.orderchartxaxis.map(season => season.replace(/-20/, "/") );
     formattedSeasons = formattedSeasons.map(season => season.replace(/20/, "") );

    this.chartOptions = {
      // Data retrieved from https://en.wikipedia.org/wiki/Winter_Olympic_Games
      chart: {
        type: 'column'
      },

      title: {
        text: '',
        align: 'left'
      },

      xAxis: {
        categories: formattedSeasons,
        labels: {
          style: {
            color: '#000',
            fontSize: '16px',
            fontFamily: 'Campton-Medium',
            fontWeight: '500',
            lineHeight: '24px',
            transform: 'none'
          }
        }
      },

      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: ''
        },
        tickPositioner: function () {
          return orderchartyaxis;
        },
        labels: {

          formatter: function () {
            if (typeof this.value === 'number' && this.value > 0) {
              return this.value + 'k';
            } else {
              return this.value.toString();
            }
          }
        }
      },

      tooltip: {
        valueSuffix: 'k',
        format: '<b>{key}</b><br/>{series.name}: {y}k'
      },

      plotOptions: {
        column: {
          stacking: 'normal',
          borderRadius: 0
        }
      },

      series: [
        
        {
          type: 'column',
          name: this.productname2,
          color: '#DB7E04',
          data: qivc,
          stack: 'Europe'
        },
        {
          type: 'column',
          name: this.productname1,
          color: '#4ECFF8',
          data: aqiv,
          stack: 'Europe'
        },
      ]


    }
  }
  setreturnHighchart(aqiv: any, qivc: any) {
    const orderchartyaxis = this.yaxisreturn;
    let formattedSeasons = this.orderchartxaxis.map(season => season.replace(/-20/, "/") );
    formattedSeasons = formattedSeasons.map(season => season.replace(/20/, "") );

    this.chartOptionsreturn = {
      // Data retrieved from https://en.wikipedia.org/wiki/Winter_Olympic_Games
      chart: {
        type: 'column'
      },

      title: {
        text: '',
        align: 'left'
      },

      xAxis: {
        categories: formattedSeasons,
        labels: {
          style: {
            color: '#000',
            fontSize: '16px',
            fontFamily: 'Campton-Medium',
            fontWeight: '500',
            lineHeight: '24px',
            transform: 'none'
          }
        }
      },

      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: ''
        },
        tickPositioner: function () {
          return orderchartyaxis;
        },
        labels: {

          formatter: function () {
            if (typeof this.value === 'number' && this.value > 0) {
              return this.value + 'k';
            } else {
              return this.value.toString();
            }
          }
        }
      },

      tooltip: {
        valueSuffix: 'k',
        format: '<b>{key}</b><br/>{series.name}: {y}k'
      },

      plotOptions: {
        column: {
          stacking: 'normal',
          borderRadius: 0
        }
      },

      series: [
       
        {
          type: 'column',
          name: this.productname2,
          color: '#DB7E04',
          data: qivc,
          stack: 'Europe'
        },
        {
          type: 'column',
          name: this.productname1,
          color: '#4ECFF8',
          data: aqiv,
          stack: 'Europe'
        },
      ]


    }
  }
}
